import { useSetSearchParams } from '@hook/useSetSearchParams';
import { fetchData } from '@network/querys';
import type React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface IRadioSelect {
    watch: string;
    cls: string;
    title: string;
    path: string;
    resetObj: Record<string, string>;
    ga360str: string;
    activeBless: string | null;
    submitCallback?: (_d: string) => void;
}

export const RadioSelect = ({ props }: { props: IRadioSelect }) => {
    const { watch, cls, title, path, submitCallback, resetObj, ga360str, activeBless } = props;
    const articleRef = useRef<HTMLElement>(null);
    const setParams = useSetSearchParams();
    const [dat, datSet] = useState<Array<{ id: string; name: string }>>([]);
    const [checkItems, setCheckItems] = useState('0');
    const { t } = useTranslation();

    useEffect(() => {
        fetchData(path).then((res: Array<{ id: string; name: string }>) => {
            res.unshift({ id: '0', name: t('common.all') });
            datSet(res.map((it) => ({ id: it.id.toString(), name: it.name })));
        });
    }, [path, t]);

    useEffect(() => {
        setCheckItems(!activeBless ? '0' : activeBless);
    }, [activeBless]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.currentTarget.value;
        setParams({ [watch]: val, ...resetObj });
        submitCallback?.(val);
    };

    return (
        <section className={cls}>
            <header>{title}</header>
            <article className="radio-wrapper" data-areas={ga360str} ref={articleRef}>
                {dat.map((it, idx) => (
                    <span className="radio" key={cls + idx + it.id}>
                        <input
                            type="radio"
                            id={`${watch}_radio_${it.id}`}
                            name={`${watch}_radio_${it.id}`}
                            value={it.id}
                            checked={checkItems === it.id}
                            onChange={onChange}
                        />
                        <label htmlFor={`${watch}_radio_${it.id}`} data-areas={ga360str}>
                            {it.name}
                        </label>
                    </span>
                ))}
            </article>
        </section>
    );
};
